
import { useEffect } from 'react'
import Select from 'react-select'
import { ParamaterDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const ParameterDDL = (props) => {
    const { ParameterID, setParameterID, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            WaterQtyM_IndicatorID: '0',
            M_UserID: UserID,
            token: token,
            Flag: Flag
        }
        dispatch(ParamaterDDLAPI({ data }))
    }, [])

    const { ParamaterData } = useSelector(state => state.ParamaterDDLData)

    useEffect(() => {
        handleWorkAssignByDDL()
    }, [ParamaterData])

    const handleWorkAssignByDDL = () => {
        // console.log(DeptDDLDataa)
        if (ParamaterData && ParamaterData.table && ParamaterData.table.length > 0) {
            let list = ParamaterData.table.map((item, index) => ({
                value: item.m_IndicatorID,
                label: item.indicatorName,
            }))

            setParameterID({
                ...ParameterID,
                DDL: list,
                // ID: list[0].value,
                // Label: list[0].label,
                ID: localStorage.getItem('ParameterID') ? localStorage.getItem('ParameterID') : list[0].value,
                Label: localStorage.getItem('ParameterIDLabel') ? localStorage.getItem('ParameterIDLabel') : list[0].label,
            })
        }
        else {
            setParameterID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }


    }

    const handleChangeParameter = (e) => {
        setParameterID({ ...ParameterID, ID: e.value, Label: e.label })
        localStorage.setItem('ParameterID', e.value);
        localStorage.setItem('ParameterIDLabel', e.label);
    }

    const handleClearParameter = (e) => {
        setParameterID({ ...ParameterID, ID: 0, Label: "Select" })
        localStorage.removeItem('ParameterID');
        localStorage.removeItem('ParameterIDLabel');
    }

    return (
        <div className="form-group">
            <Select
                isClearable={true}
                isSearchable
                maxMenuHeight='130px'
                value={{ value: ParameterID.ID, label: ParameterID.Label }}
                onChange={(e) => {
                    e ?
                        handleChangeParameter(e)

                        :
                        handleClearParameter()

                }}
                options={ParameterID.DDL}
            />
        </div>
    )
}